module.exports = __webpack_public_path__ + "img/HQTS-color.606a75ba.png";